var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplaceLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 211,
    viewBox: "0 0 272 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M261.037 178C48.5371 193 71.0371 236.5 166.037 141C261.037 45.4998 271.037 19.5 90.5371 86.5C-89.9629 153.5 87.0371 84.5 103.037 10",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceLine);
export default __webpack_public_path__ + "static/media/marketplace-line.b89df13e854a92f7697aa9493f0e587e.svg";
export { ForwardRef as ReactComponent };